module.exports = __webpack_public_path__ + "img/testimonials-trustpilot-logo.8666f039.svg";